// "Nothing selected" empty state for the thread (middle) pane — shown when
// no feedback item is selected. Design-spec per
// veda:projects/unified-feedback-inbox/prototype/v69/index.html:951-957
// (`.ib-empty-convo`) and :1927 (`.iec-ic`/`.iec-t`/`.iec-s`).
//
// Lives under `ThreadPane/` even though PR 04 (this chassis PR) mounts it
// directly from `FeedbackInbox/index.tsx` — PR 05 introduces
// `ThreadPane/index.tsx` and takes over rendering the thread pane's
// contents (including this empty state) from the container.
import ChatBubble from 'components/Icons/ChatBubble'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'

const t = buildTranslate('feedback_inbox.thread')

const EMPTY_ICON_DISC_PX = 62
const EMPTY_ICON_PX = 30
const EMPTY_STATE_GAP_PX = 13
const EMPTY_STATE_PADDING_PX = 40
const EMPTY_BODY_MAX_WIDTH_CH = 34

const NothingSelected = () => {
  const [css] = useStyletron()

  return (
    <div
      className={css({
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: `${EMPTY_STATE_GAP_PX}px`,
        padding: `${EMPTY_STATE_PADDING_PX}px`,
        textAlign: 'center',
        boxSizing: 'border-box',
      })}
    >
      <div
        className={css({
          width: `${EMPTY_ICON_DISC_PX}px`,
          height: `${EMPTY_ICON_DISC_PX}px`,
          borderRadius: '50%',
          backgroundColor: palette.grey05,
          color: palette.grey30,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        })}
      >
        <ChatBubble
          className={css({
            width: `${EMPTY_ICON_PX}px`,
            height: `${EMPTY_ICON_PX}px`,
          })}
        />
      </div>
      <p
        className={css({
          fontSize: '17px',
          fontWeight: 800,
          color: palette.grey90,
          margin: 0,
        })}
      >
        {t('nothing_selected_title')}
      </p>
      <p
        className={css({
          fontSize: '14px',
          color: palette.grey70,
          maxWidth: `${EMPTY_BODY_MAX_WIDTH_CH}ch`,
          lineHeight: '1.5',
          margin: 0,
        })}
      >
        {t('nothing_selected_body')}
      </p>
    </div>
  )
}

export default NothingSelected
